import { BILLING_CYCLE } from "api/interfaces/subscription.interface";
import {
  TERM_DISCOUNT_YEAR,
  YearPaymentPrice,
} from "api/interfaces/planInterface.interface";
import { formatNumber } from "./functions";

export const truncateToTwoDecimals = (value: number): number => {
  const cleaned = Math.round(value * 1e8) / 1e8;
  return Math.floor(cleaned * 100) / 100;
};

export const isYearlyBillingCycle = (
  cycle?: BILLING_CYCLE
): cycle is BILLING_CYCLE.YEARLY | BILLING_CYCLE.TEST_YEARLY =>
  cycle === BILLING_CYCLE.YEARLY || cycle === BILLING_CYCLE.TEST_YEARLY;

const TERM_YEARS_TO_DISCOUNT_YEAR: Record<number, TERM_DISCOUNT_YEAR> = {
  1: TERM_DISCOUNT_YEAR.YEAR1,
  2: TERM_DISCOUNT_YEAR.YEAR2,
  3: TERM_DISCOUNT_YEAR.YEAR3,
};

export const getYearDiscount = (
  year: YearPaymentPrice[] | undefined,
  termYears: number
): number => {
  const name = TERM_YEARS_TO_DISCOUNT_YEAR[termYears];
  return year?.find((item) => item.name === name)?.discount ?? 0;
};

export const getYearlyChannelPrice = (
  monthlyChannelPrice: number,
  yearDiscount: number
): number =>
  truncateToTwoDecimals(monthlyChannelPrice * 12 * (1 - yearDiscount / 100));

export const getPrepaidTotal = (
  quantity: number,
  yearlyUnitPrice: number,
  termYears: number = 1
): number => truncateToTwoDecimals(quantity * yearlyUnitPrice * termYears);

export const formatNumberUtil = (value: number, fractionDigits: number = 2) =>
  String(formatNumber(value, { fractionDigits, truncate: true }) ?? "0");

export const formatPrice = (value: number): string =>
  formatNumberUtil(value, 2);
